// 취소 건 카드 보조 표시 — 짧은 사유 배지 + [다시 신청] 링크 (앱 simple_request_card.dart 패리티).
// 사유 코드가 없는 옛 취소 건(서버 미배포 시절)은 둘 다 렌더하지 않는다 — DetailBody 의 역호환 규칙과 같다.
// 문구는 기존 키만 쓴다: evalCancelReasonShort_<code> · cancelReasonReapply.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { T, FONT, R } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import { cancelNeedsResubmit } from '../fmt';

// 상태 필(SimpleStatusPill)과 같은 높이·회색 톤 — 필 옆에 나란히 선다.
var badge = {
  display: 'inline-flex', alignItems: 'center', height: 22, padding: '0 9px', borderRadius: R.pill,
  fontSize: FONT.badge + 0.5, fontWeight: 700, whiteSpace: 'nowrap', flex: 'none', boxSizing: 'border-box',
  color: T.muted, background: T.track, border: '1px solid ' + T.bd
};
// 카드 루트가 <button> 이라 중첩 버튼을 만들 수 없다 — role="link" 스팬 + 클릭 전파 차단.
var link = {
  display: 'inline-block', alignSelf: 'start', marginTop: 4, padding: '2px 0',
  fontSize: 11.5, fontWeight: 700, color: T.accent, cursor: 'pointer'
};

/// 짧은 사유 배지. props: { order }
export function CancelReasonBadge(props) {
  var t = useT();
  var o = props.order || {};
  if (o.status !== 'cancelled' || !o.cancel_reason_code) return null;
  return (<span className="ss-cancel-reason" data-cancel-reason={o.cancel_reason_code} style={badge}>
    {t('evalCancelReasonShort_' + o.cancel_reason_code)}
  </span>);
}

/// [다시 신청] — 재신청 안내 사유일 때만. 경로·파라미터는 DetailBody 의 reapply 와 같다(차종·차량번호 프리필).
export function ReapplyLink(props) {
  var t = useT();
  var navigate = useNavigate();
  var o = props.order || {};
  if (o.status !== 'cancelled' || !cancelNeedsResubmit(o.cancel_reason_code)) return null;
  var go = function (e) {
    e.stopPropagation();
    var params = new URLSearchParams();
    if (o.car_model) params.set('model', o.car_model);
    if (o.car_number) params.set('plate', o.car_number);
    var qs = params.toString();
    navigate('/main/s/request' + (qs ? '?' + qs : ''));
  };
  return (<span className="ss-reapply" role="link" tabIndex={0} data-action="reapply" style={link}
    onClick={go} onKeyDown={function (e) { if (e.key === 'Enter') go(e); }}>
    {t('cancelReasonReapply')}
  </span>);
}
